module.exports = __webpack_public_path__ + "img/Speaker=Wendy Cukier.daff8025.png";